import React from 'react';
import SectionSummary, {
  SectionSummaryGroupPosition,
} from '../../summary/SectionSummary';

export type AuthenticatedContactSectionProps = {
  emailAddress: string;
  groupPosition?: SectionSummaryGroupPosition;
  onLogout?: () => void;
};

const AuthenticatedContactSection: React.FC<
  AuthenticatedContactSectionProps
> = ({
  emailAddress,
  groupPosition,
  onLogout,
}: AuthenticatedContactSectionProps) => {
  return (
    <SectionSummary
      title="Email"
      content={emailAddress}
      displayActionButton
      actionButtonText="Logout"
      onActionButtonClicked={onLogout}
      groupPosition={groupPosition}
      toolTipKey="AuthenticatedContactSection"
    />
  );
};

export default AuthenticatedContactSection;
